import type { RouteObject } from 'react-router';
import { HUB_PATHS } from '@traceio-org/platform-contracts';

/** The start page, loaded once on first use (the import is cached), so the sign-in pages stay small. */
const load = () => import('./pages');

/**
 * Start your trial (spec 2026-10-18 piece 5): /start?setup=<the pricing page's setup code>, and
 * /start?signup=<id>&checkout=done|canceled when Stripe Checkout returns. Signed in, no organization needed: the founder
 * has none yet. platform-api decides every request again.
 */
export function startRoutes(): RouteObject[] {
  return [
    { path: HUB_PATHS.start.slice(1), lazy: async () => ({ Component: (await load()).StartTrialPage }) },
  ];
}
